export type Listener<T> = (event: T) => any;

export class EventBus<T = void> {
	private readonly listeners: Listener<T>[] = [];

	/**
	 * @returns Disposer function
	 */
	on(listener: Listener<T>): () => void {
		this.listeners.push(listener);
		return () => this.off(listener);
	}

	off(listener: Listener<T>) {
		const callbackIndex = this.listeners.indexOf(listener);
		if (callbackIndex !== -1) {
			this.listeners.splice(callbackIndex, 1);
		}
	}

	emit(event: T) {
		this.listeners.forEach(listener => listener(event));
	}
}
